import { KpiFactboxSingleMetricVizViews } from '../types';
import { singleColumnFactboxViewConfig } from './single-column-factbox/view-config';

export const singleMetricKpiFactboxViewConfigs = [
  {
    name: KpiFactboxSingleMetricVizViews.FACTBOX,
    viewConfig: singleColumnFactboxViewConfig,
  },
];
